<template>
    <BaseSection
        v-if="quote"
        section-width="content"
    >
        <template #default>
            <BaseQuote
                :image="image?.[0]"
                :quote="quote"
                :author="author"
                :external-link="blockQuoteExternalLink"
                :internal-link="blockQuoteInternalLink?.[0]?.uri"
            />
        </template>
    </BaseSection>
</template>

<script setup lang="ts">
type Props = {
    quote?: string | null;
    author?: string | null;
    image?: {
        url
    }[];
    linkText?: string;
    blockQuoteExternalLink?: string;
    blockQuoteInternalLink?: {
        uri?: string;
    }[];
};

defineProps<Props>();
</script>
